import styled from "styled-components";
import { rem } from "convert-to-ems";

export const HorizontalScrollElement = styled.div`
  display: flex;
  overflow-x: auto;
  padding-left: ${props => rem(props.paddingLeft)};
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Container = styled.div`
  margin: 0 auto;
  padding-right: ${props => rem(props.paddingRight)};
`;
